export const bookList = [{
    shId: 'DruSg',
    cover: 'http://imgb2.chineseall.cn/bookcover/650/655/486/61423826_st_300_400.jpg',
    name: '诺博士',
    author: '(英)伊恩·弗莱明著',
    intro: '本书为长篇小说，系007典藏系列中的一种，小说中英国政府派邦德前往牙买加调查一桩情报人员失踪案件，007几经调查，发现此案与蟹角岛上的诺博士有关。007在当地人的帮助下潜入蟹角岛，并偶遇了美丽的荒原美女哈妮，经历了逃避追捕和不幸被俘后，007发现了诺博士的惊天阴谋。在哈妮的帮助下，007粉碎了诺博士的诡计拯救了世界。小说故事情节扣人心弦，阴谋的复杂与庞大令读者叹为观止。',
    url: '/v3/book/detail/DruSg',
    wUrl: '/book/detail/DruSg/cover'
  },
  {
    shId: 'ByuSg',
    cover: 'http://imgb2.chineseall.cn/bookcover/657/662/493/61423833_st_300_400_1.jpg',
    name: '生死攸关',
    author: '(英)伊恩·弗莱明著',
    intro: '本书系“007典藏系列”的一种，系一部长篇小说。小说讲述了邦德受命前往美国调查三名情报人员的死因，却因此而牵连出一桩轰动世界的毒品大案的故事。在故事中，邦德屡屡靠自己的英勇机智化险为夷，与敌人周旋，情节精彩好看，可读性强。',
    url: '/v3/book/detail/ByuSg',
    wUrl: '/book/detail/ByuSg/cover'
  },
  {
    shId: 'ZyuSg',
    cover: 'http://imgb2.chineseall.cn/bookcover/656/661/492/61423832_st_300_400.jpg',
    name: '生死时刻',
    author: '(英)伊恩·弗莱明著',
    intro: '本书是一部长篇小说。在本书中，世界巨富航业大亨史登堡为征服世界，满足野心，建立了一座“海底城”。他高薪聘请科学家发展潜水艇跟踪系统，将英、苏核子动力潜艇占为己有，并将其配置的核子飞弹对准纽约和莫斯科，准备一口气消灭两个超级强国，雄霸世界。正当英、苏双方无计可施时，007与苏联女情报员一起来到海底基地，在一场斗智斗勇的生死之战后，终于毁掉了基地。',
    url: '/v3/book/detail/ZyuSg',
    wUrl: '/book/detail/ZyuSg/cover'
  },
  {
    shId: '6XuSg',
    cover: 'http://imgb2.chineseall.cn/bookcover/659/664/495/61423835_st_300_400_1.jpg',
    name: '最高机密',
    author: '(英)伊恩·弗莱明著',
    intro: '本书为一部长篇小说。在这部小说中，邦德接到一单新任务，英国三名情报人员在美国遇害，英政府却无法查出凶手，邦德赶赴异邦调查真相，意外发现这宗案件不仅与邪恶的巫术有关，还牵涉一桩将牵动全世界的毒品案件。邦德孤身深入敌营，经过危险重重的侦查，最终粉碎了敌人的阴谋。',
    url: '/v3/book/detail/6XuSg',
    wUrl: '/book/detail/6XuSg/cover'
  },
  {
    shId: 'SduSg',
    cover: 'http://imgb2.chineseall.cn/bookcover/653/658/489/61423829_st_300_400.jpg',
    name: '黎明杀机',
    author: '(英)伊恩·弗莱明著',
    intro: '本书为一部长篇小说，詹姆斯·邦德到捷克掩护苏联间谍戈斯科夫叛逃，联络员帮助邦德通过地下管道把叛逃者带到西方。戈斯科夫仅供出苏军大将布什金正在进行一项“杀死间谍”的军事行动，就被人绑架了。邦德再度到捷克，并了解到戈斯科夫的叛逃只为了转移西方视线，布什金的目的是大宗国际军火贸易。邦德与对方展开激烈的战斗。最后，邦德出人意料地破坏了苏军的空军基地。',
    url: '/v3/book/detail/SduSg',
    wUrl: '/book/detail/SduSg/cover'
  },
  {
    shId: 'PyuSg',
    cover: 'http://imgb2.chineseall.cn/bookcover/658/663/494/61423834_st_1.jpg',
    name: '择日而亡',
    author: '(英)伊恩·弗莱明著',
    intro: '本书为一部长篇小说，写的是美国太空船在太空中被不明飞行物攻击，美方怀疑是苏联方面的阴谋。因不明飞行物的降落地点在日本，詹姆斯·邦德被派往日本替美方调查此事。詹姆斯·邦德在经过一番调查之后，发现敌人不是苏联，也不是日本政府，而是日本一家化学公司下属的私人公司——大理公司，其老板是魔鬼党的一员。詹姆斯·邦德与犯罪分子展开殊死搏斗，最终取得了胜利。',
    url: '/v3/book/detail/PyuSg',
    wUrl: '/book/detail/PyuSg/cover'
  }
]